export default [{
    path: '/nation',
    name: 'nation',
    meta: {
      layout: 'main'
    },
    component: () => import('@/views/nation/index')
  }]
  